import { ApiCaller } from '@graphit/callers'
import { queryOptions, useMutation, useQueryClient, useSuspenseQuery } from '@tanstack/react-query'

export const usersQueryOptions = queryOptions({
	queryKey: ['users'],
	queryFn: ApiCaller.getAllUsers
})

export const useUsersQuery = () => useSuspenseQuery(usersQueryOptions)

export const useUpdateUserPlanMutation = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: async ({ userId, plan }: { userId: string; plan: string }) =>
			ApiCaller.updateUserPlan(userId, plan),
		onSuccess: async () => queryClient.invalidateQueries({ queryKey: ['users'] })
	})
}

export const useMakeUserAdminMutation = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ApiCaller.makeUserAdmin,
		onSuccess: async () => queryClient.invalidateQueries({ queryKey: ['users'] })
	})
}

export const useRevokeUserAdminMutation = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ApiCaller.revokeUserAdmin,
		onSuccess: async () => queryClient.invalidateQueries({ queryKey: ['users'] })
	})
}

export const useSoftDeleteUserMutation = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ApiCaller.softDeleteUser,
		onSuccess: async () => queryClient.invalidateQueries({ queryKey: ['users'] })
	})
}

export const useDeleteUserDataMutation = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ApiCaller.deleteUserData,
		onSuccess: async () => queryClient.invalidateQueries({ queryKey: ['users'] })
	})
}

export const usePrepareDeletionMutation = () =>
	useMutation({
		mutationFn: ApiCaller.prepareDeletion
	})
